/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-02-03 20:22:36
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-15 12:34:25
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/ProductsSelection/tools.tsx
 */
import { ProductItem } from 'src/types/common/product';
import _ from 'lodash';
import React from 'react';
import Tags from 'src/components/Tags/Tags';
import { useItemsChange } from 'src/tools/hooks/useItemChangeWithOrder';
interface IPrePro {
  product: ProductItem;
  uuid: string;
  [propsName: string]: any;
}
export const _formatProductSetData = (productSet = []) => {
  return productSet.map((i) => {
    const { product = {} } = i;
    const { uuid } = product;
    return { ...i, uuid };
  });
};
export const _formatArrToMap = (
  arr = [],
): { [propName: string]: ProductItem } => {
  return arr.reduce((pre, now) => {
    const { uuid } = now;
    return { ...pre, [uuid]: now };
  }, {});
};
const onOkCompare = (
  latestProducts: ProductItem[] = [],
  previousProducts: IPrePro[] = [],
  generateProductSetItem,
) => {
  const mappedLatestProducts = _formatArrToMap(latestProducts);

  const filtePreviousProducts = previousProducts.reduce((pre, now) => {
    let { uuid } = now || {};
    const { product } = now || {};
    if (!uuid) {
      uuid = product.uuid;
    }
    if (mappedLatestProducts[uuid]) {
      //原来的还在新的list里面
      delete mappedLatestProducts[uuid];
      return [...pre, now];
    } else {
      return pre; //原来的不在新的list里面
    }
  }, []);

  if (Object.values(mappedLatestProducts).length > 0) {
    Object.values(mappedLatestProducts).forEach((i) => {
      if (generateProductSetItem) {
        const item = generateProductSetItem(i);
        filtePreviousProducts.push(item);
      }
    });
  }

  return filtePreviousProducts;
};
const updateMappedSelectedKeys = (mappedSelectedKeys, selectedRowKeys) => {
  const _keys = _.cloneDeep(mappedSelectedKeys); //{uuid:{}}
  selectedRowKeys.forEach((i) => {
    const { uuid, product } = i;
    if (uuid) {
      if (!_keys[uuid]) {
        _keys[uuid] = { checked: true, current: false }; //不在当前页
      }
      _keys[uuid].checked = true;
      _keys[uuid].product = product;
    }
  });
  Object.keys(_keys).forEach((i) => {
    if (
      _keys[i].current && //_keys ->总表
      _keys[i].checked && //selectedRowKeys->当前页
      !selectedRowKeys.map((i) => i.uuid).includes(i)
    ) {
      _keys[i].checked = false;
      _keys[i].product = null;
    }
    _keys[i].current = false;
  });

  return _keys || {};
};

const onSelectChange = (selections, mappedProducts, setSelectedRowKeys) => {
  const res = selections.map((i) => {
    return {
      uuid: i,
      product: mappedProducts[i],
    };
  });
  setSelectedRowKeys(res);
};

const generateMappedSelectedKeys = (selectedItems = []) => {
  return selectedItems.reduce((pre, now) => {
    return {
      ...pre,
      [now.uuid]: {
        current: false,
        checked: true,
        product: now,
      },
    };
  }, {});
};

const generateTags = (filter, clearProductType) => {
  return Object.keys(filter).map((key) => {
    const name = filter[key].map((value) => value.name);
    return (
      <Tags
        key={key}
        onClose={(e, index) => clearProductType(key, index)}
        data={name}
      />
    );
  });
};

const generateScrollProps = (products) => {
  if ((products || []).length > 5) {
    return { x: 'max-content', y: 360 };
  }
  return { x: 'max-content', y: 360 };
};

const onOkClick = (updateMappedSelectedKeys, onOk, onCancel) => {
  const selectedProducts = Object.values(updateMappedSelectedKeys()).reduce(
    (pre: any, now: any) => {
      if (now.checked) {
        return [...pre, now.product];
      } else {
        return pre;
      }
    },
    [],
  );

  onOk(selectedProducts);
  onCancel();
};

export {
  generateMappedSelectedKeys,
  onOkCompare,
  updateMappedSelectedKeys,
  onSelectChange,
  generateTags,
  generateScrollProps,
  onOkClick,
};

export const onItemsChange = (
  selectedItems, //原来选择的
  products, //当前页面的所有数据
  onOk,
  onCancel,
  extraProps?,
) => {
  return useItemsChange(
    selectedItems, //原来选择的
    products, //当前页面的所有数据
    onOk,
    onCancel,
    extraProps,
  );
};
